import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Check, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const VerificationRequired = () => {
  const { t } = useTranslation();
  const { user, setUser } = useAuth();
  const [status, setStatus] = useState('idle'); // idle | verifying | done

  const handleVerify = () => {
    setStatus('verifying');
    // Simulate a quick verification (1.5s)
    setTimeout(() => {
      setStatus('done');
      // Force the local user context to "verified"
      if (setUser && user) {
        setUser({ ...user, identity_verified: true, phone_verified: true, face_verified: true });
      }
    }, 1500);
  };

  if (status === 'done') {
    return (
      <div data-testid="verification-success" style={{
        background: '#f0fdf4', borderRadius: '16px', padding: '2rem', textAlign: 'center',
        border: '2px solid #86efac', maxWidth: '420px', margin: '2rem auto'
      }}>
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%', margin: '0 auto 1rem',
          background: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <Check size={28} color="white" />
        </div>
        <h2 style={{ color: '#15803d', marginBottom: '0.5rem', fontSize: '1.2rem' }}>
          {t('verification.verified') || 'Verifizierung erfolgreich!'}
        </h2>
        <p style={{ color: '#166534', fontSize: '0.9rem' }}>
          {t('verification.successMessage') || 'Du bist jetzt verifiziert. Lade die Seite neu, um fortzufahren.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          data-testid="verification-reload-btn"
          style={{
            marginTop: '1rem', padding: '0.75rem 2rem', background: '#22c55e', color: 'white',
            border: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer'
          }}
        >
          {t('common.continue') || 'Weiter'}
        </button>
      </div>
    );
  }

  return (
    <div data-testid="verification-required" style={{
      background: '#fffbeb', borderRadius: '16px', padding: '2rem', textAlign: 'center',
      border: '2px solid #fcd34d', maxWidth: '420px', margin: '2rem auto'
    }}>
      <div style={{
        width: '56px', height: '56px', borderRadius: '50%', margin: '0 auto 1rem',
        background: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Shield size={28} color="white" />
      </div>
      <h2 style={{ color: '#92400e', marginBottom: '0.5rem', fontSize: '1.2rem' }}>
        {t('verification.title') || 'Identitatsverifizierung erforderlich'}
      </h2>
      <p style={{ color: '#78350f', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
        {t('verification.description') || 'Bitte verifiziere deine Identitat, bevor du Fahrten anbieten oder buchen kannst.'}
      </p>
      <button
        onClick={handleVerify}
        disabled={status === 'verifying'}
        data-testid="verify-now-btn"
        style={{
          padding: '0.85rem 2.5rem', border: 'none', borderRadius: '12px', fontWeight: 700, fontSize: '1rem',
          cursor: status === 'verifying' ? 'not-allowed' : 'pointer',
          background: status === 'verifying' ? '#d1d5db' : 'linear-gradient(135deg, #2563eb, #1d4ed8)',
          color: 'white', display: 'inline-flex', alignItems: 'center', gap: '0.5rem'
        }}
      >
        {status === 'verifying' ? (
          <><Loader2 size={18} style={{ animation: 'spin 1s linear infinite' }} /> Verifiziere...</>
        ) : (
          <><Shield size={18} /> {t('verification.verifyNow') || 'Jetzt verifizieren'}</>
        )}
      </button>
    </div>
  );
};
